import { Outlet } from 'react-router';

import { useTypedParams } from '@sorare/routing';
import type { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';

import { FixtureTabLayout } from '#src/layouts/FixtureLayout/FixtureTabLayout/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const ArenaFixtureLayout = () => {
  const { fixture, eventType } = useTypedParams<PageParams>();

  return (
    <FixtureTabLayout
      so5FixtureSlug={fixture}
      eventType={eventType.toUpperCase() as So5FixtureEvent}
    >
      <Outlet />
    </FixtureTabLayout>
  );
};

export default ArenaFixtureLayout;
